import { ConstantVariables } from "../../../Helpers/ConstantVariables";
import { PdfViewer, Toolbar, Magnification, Navigation, LinkAnnotation} from '@syncfusion/ej2-pdfviewer';
import { Spreadsheet } from '@syncfusion/ej2-spreadsheet';

export class DocAttachmentsPopupManager {

    constructor(private containerElement: JQuery) { }

    private attachmentContainer : JQuery<HTMLElement>;
    private pdfViewer?: PdfViewer;
    private spreadsheet?: Spreadsheet;

    public initialize(docHeaderId : string, docRevisionId : string) {
        var self = this;

        self.attachmentContainer = self.containerElement.find('#attachment-container');

        self.containerElement.find('tbody > tr').each((index, element) => {
            var tableRow = $(element);

            tableRow.off('click').on('click', () => {
                self.containerElement.find('tr.active').removeClass('active');
                tableRow.addClass('active');

                self.loadAttachment(tableRow.data('attachment-id'));
            });
        })

        self.containerElement.find('.btn[data-download-button]').off('click').on('click', (e) => {
            e.stopImmediatePropagation();
        })


        self.containerElement.find('tbody > tr').first().trigger('click');

    }

    private loadAttachment(attachmentId : any) {
        var self = this;
        self.attachmentContainer.html(ConstantVariables.SpinnerHtmlWithMargin).load(`?attachmentId=${attachmentId}&handler=LoadAttachmentDetails`, () => {
            self.attachmentDetailsLoaded();
        });
    }

    private attachmentDetailsLoaded() {
        var self = this;
        var dataContainer = self.attachmentContainer.children().first();
        self.clearViewers();

        if(dataContainer.data('is-pdf') == "true" || dataContainer.data('is-pdf') == "True") {
            PdfViewer.Inject(Toolbar, Magnification, Navigation, LinkAnnotation);

            var spinner = self.containerElement.find('#pdf-spinner');
            var pdfViewerContainer = self.attachmentContainer.find('#pdf-viewer');
    
            self.pdfViewer = new PdfViewer({
                documentPath: pdfViewerContainer.data('path'),
                enableNavigationToolbar: false,
                enableStickyNotesAnnotation: false,
                enableThumbnail: false,
                enableBookmark: false,
                enableHyperlink: false,
                enableAnnotationToolbar: false,
                enableDownload: false,
                toolbarSettings: {
                    showTooltip: false,
                    toolbarItems: ['PageNavigationTool', 'MagnificationTool']
                },
                height: '77vh',
                created: () => {
                    spinner.remove();
                },
                documentLoad: (args) => {
                    var formFields = self.pdfViewer.retrieveFormFields();
                    formFields.map((formField) => {
                        var isReadOnly : any = { isReadOnly: true };
                        self.pdfViewer.formDesignerModule.updateFormField(formField, isReadOnly);
                    });
                }
            });
    
            self.pdfViewer.appendTo('#pdf-viewer');
        }
        else if(dataContainer.data('is-excel') == "true" || dataContainer.data('is-excel') == "True") {
            self.spreadsheet = new Spreadsheet( {
                showRibbon: false,
                showAggregate: false,
                showFormulaBar: false,
                allowEditing: false,
                height: '77vh',
                openUrl: '/api/company/excel/open',
                created: (): void => {
                    fetch(dataContainer.children().first().data('url')) // fetch the remote url
                        .then((response) => {
                            response.blob().then((fileBlob) => { // convert the excel file to blob
                                let file = new File([fileBlob], "Sample.xlsx");
                                self.spreadsheet.open({ file: file }); // open the file into Spreadsheet
                            })
                        })
                },
                openComplete: (args: any) => {
                    if(args.response.data == 'NeedPassword' || args.response.data == 'InCorrectPassword') {
                        //spreadsheetElement.removeClass('d-none');
                    }
                    else if(args.response.data == 'UnsupportedFile') {
                        //spreadsheetElement.removeClass('d-none');
                    }
                    else {
                        self.spreadsheet.selectRange('A1:A1');

                        setTimeout(() => {
                            self.spreadsheet.freezePanes(0, 0);  
                        }, 250)
                                                                    
                    }
                },
            });
            self.spreadsheet.appendTo('#view-excel-file-container');
        }
    }

    private clearViewers(): void {
        var self = this;
        if (self.pdfViewer) {
            self.pdfViewer.destroy();
            self.pdfViewer = undefined;
        }

        if (self.spreadsheet) {
            self.spreadsheet.destroy();
            self.spreadsheet = undefined;
        }

        $('#pdf-viewer').empty();
        $('#view-excel-file-container').empty();
        $('#pdf-spinner').remove();
        $('#pdf-viewer_signElement').remove();
    }




}